/**
 * GavelHit — small animated mascot that "swings" the gavel on each countdown tick.
 * Retriggered by changing `tick` prop (React reuses same DOM but restarts animation via key).
 * Shows only when active === true.
 */
export default function GavelHit({ tick, active, size = 56 }) {
  if (!active) return null;
  const critical = typeof tick === "number" && tick <= 1;
  return (
    <div
      key={tick}
      data-testid="gavel-hit"
      className="relative inline-flex items-center justify-center"
      style={{ width: size, height: size }}
    >
      <div className="absolute inset-0 rounded-full"
           style={{
             background: critical ? "radial-gradient(circle, rgba(239,68,68,.5) 0%, transparent 70%)" : "radial-gradient(circle, rgba(16,185,129,.45) 0%, transparent 70%)",
             animation: "gavelPulse .8s ease-out both",
           }} />
      <img
        src="/logo.jpg"
        alt=""
        className="relative rounded-xl object-cover ring-2"
        style={{
          width: size, height: size,
          borderColor: critical ? "rgba(239,68,68,.7)" : "rgba(16,185,129,.6)",
          animation: `gavelSwing .85s cubic-bezier(.36,.07,.19,.97) both`,
          transformOrigin: "50% 60%",
        }}
      />
      <span
        className="absolute font-black text-xs sm:text-sm tracking-widest"
        style={{
          bottom: -14,
          color: critical ? "#F87171" : "#34D399",
          textShadow: `0 0 8px ${critical ? "rgba(239,68,68,.7)" : "rgba(16,185,129,.7)"}`,
          animation: "gavelShout .85s ease-out both",
        }}
      >
        {critical ? "SMASH!" : "TOC!"}
      </span>
      <style>{`
        @keyframes gavelSwing {
          0% { transform: rotate(-25deg) scale(1) }
          40% { transform: rotate(20deg) scale(1.1) }
          55% { transform: rotate(18deg) scale(1.05) }
          70% { transform: rotate(18deg) scale(1.02) translateY(2px) }
          100% { transform: rotate(0) scale(1) }
        }
        @keyframes gavelPulse {
          0% { opacity: .1; transform: scale(.6) }
          40% { opacity: 1; transform: scale(1.4) }
          100% { opacity: 0; transform: scale(1.9) }
        }
        @keyframes gavelShout {
          0% { opacity: 0; transform: translateY(6px) scale(.7) }
          25% { opacity: 1; transform: translateY(0) scale(1.2) }
          70% { opacity: 1; transform: translateY(0) scale(1) }
          100% { opacity: 0; transform: translateY(-4px) scale(.9) }
        }
      `}</style>
    </div>
  );
}
